import React from 'react';

const defaultFormat = (count: number) => `+ ${count} more`;

export type MaxTagPlaceholderProps = {
  omittedValues: unknown[];
  formatOmittedCount?: (count: number) => string;
};

export default function MaxTagPlaceholder({
  omittedValues,
  formatOmittedCount = defaultFormat
}: Readonly<MaxTagPlaceholderProps>) {
  const count = omittedValues.length;
  return (
    <div className="flex h-full items-center px-1 pl-2 rounded border border-neutral-100 bg-neutral-100">
      <div className="text-neutral-60 font-body text-xs font-semibold">
        {formatOmittedCount(count)}
      </div>
    </div>
  );
}
